import { createSlice } from '@reduxjs/toolkit';
import { TextUtilities } from '@pwc/pwc-deals-web-common';

export const initialState = { termsAndConditions: null, loading: false };

const termsAndConditionsSlice = createSlice({
  name: 'termsAndConditions',
  initialState,
  reducers: {
    setTermsAndConditionsRequested: (state) => {
      return {
        ...state,
        termsAndConditions: null,
        loading: true,
      };
    },
    setTermsAndConditionsReceived: (state, action) => {
      return {
        ...state,
        termsAndConditions: action.payload.map((tAndC) => ({
          ...tAndC,
          id: TextUtilities.slugify(tAndC.title, true),
        })),
        loading: false,
      };
    },
  },
});

// Actions
export const { setTermsAndConditionsRequested, setTermsAndConditionsReceived } =
  termsAndConditionsSlice.actions;

// Selectors
export const getTermsAndConditionsLoading = (state) =>
  state.termsAndConditions.loading;
export const getTermsAndConditions = (state) =>
  state.termsAndConditions.termsAndConditions;

export default termsAndConditionsSlice.reducer;
